module.exports = {
    xs: '(max-width: 320px)',
    s: '(min-width: 321px)',
    m: '(min-width: 736px)',
    l: '(min-width: 1023px)',
    xl: '(min-width: 1280px)',
};
